import React from 'react';
import ProcessingIdAnimationImg2 from "../../assets/images/ProcessingIdAnimationImg2.png";


const Magnifier = () => {

    return (
        <div className="relative">
            <div className='absolute'>
                <img src={ProcessingIdAnimationImg2} alt="Magnifying Glass" className="w-auto h-auto" />
            </div>
            <div className="w-12 h-12 ms-14 mt-8 absolute filter rounded-full backdrop-blur-[3px] scale-95"/>
        </div>
    );
};

export default Magnifier;
